import PropTypes from 'prop-types';
import React from 'react';
import i18n from '../../i18n';
import Conversation from '../../models/Conversation';
import { Button } from '@homeexchange/panorama';

export default class ButtonRating extends React.Component {
    static propTypes = {
        conversation: PropTypes.instanceOf(Conversation).isRequired,
        color: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);
        this.handleRating = this.handleRating.bind(this);
    }

    render() {
        if (this.props.conversation.hasOneOrMoreExchangeToBeRatedByUser()) {
            return (
                <Button onClick={this.handleRating} ierarchy={this.props.color} isFullWidth>
                    {this.props.conversation.getExchange().isCanceled()
                        ? i18n.t('exchange:action_comment')
                        : i18n.t('exchange:action_rate')}
                </Button>
            );
        }

        return false;
    }

    handleRating() {
        document.dispatchEvent(
            new CustomEvent('request_card', {
                detail: {
                    view: 'rating'
                }
            })
        );
    }
}
